// Validar se o arquivo é do tipo JSON
// Validar se o arquivo possui as chaves abaixo
// Validar se as chaves "não" estão vazias, nulas, em branco 
//
// "equipment_serial_number": "2000056", 
// "pim_serial_number": "2000056", 
// "am_serial_number": "20056", 
// "ventilation_board_serial_number": "200101", 
const valid_keys = [
    "equipment_serial_number",
    "pim_serial_number",
    "am_serial_number",
    "ventilation_board_serial_number",
]

const jsonValidation = (json = {}, callback = () => {}, callback_error = () => {}) => {
    if (json.type && json.type != "application/json"){
        callback_error(
            "Invalid file type"
        )
        return
    }
    var fileread = new FileReader()
    fileread.readAsText(json)
    
    fileread.onload = (e) => {
        var data = JSON.parse(e.target.result)
        for (const key of valid_keys) {
            if (data.device){
                if(!Object.keys(data.device).includes(key)){
                    callback_error(
                        "Missing value on file"
                    )
                    return 
                }
                if(!data.device[key]){
                    callback_error(
                        `Invalid ${key} value`
                    )
                    return 
                }
            }else{
                if(!Object.keys(data).includes(key)){
                    callback_error(
                        "Missing value on file"
                    )
                    return 
                }
                if(!data[key]){
                    callback_error(
                        `Invalid ${key} value`
                    )
                    return 
                }
            }
        }
        if (data.device){
            callback(data.device)
        }else{
            callback(data)
        }
    }
}

export default jsonValidation